export default {
  getMenu: () => {
    let array = [];
    let submenu = [];
    let submenu_1 = [];
    let is_admin = window.GETCCMT.$store.state.is_admin();
    let is_manager = window.GETCCMT.$store.state.is_manager();
    let is_chargerClientele = window.GETCCMT.$store.state.is_chargerClientele();
    let is_client = window.GETCCMT.$store.state.is_client();
    let is_mandataire = window.GETCCMT.$store.state.is_mandataire();
    let is_dispatcher = window.GETCCMT.$store.state.is_dispatcher();
    let is_commercial = window.GETCCMT.$store.state.is_commercial()

    // /dashboard
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      array.push({
        url: "/dashboard",
        name: "Tableau de bord",
        slug: "home",
        icon: "HomeIcon"
      });
    }

    // Demandes
    submenu = [];

    if (is_chargerClientele || is_commercial) {
      submenu.push({
        url: "/requests/assign",
        name: "Mes demandes",
        slug: "mes-requests"
      });
    }

    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests",
        name: "Toutes les demandes",
        slug: "all-requests"
      });

    }

    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests/pending",
        name: "Demandes en cours",
        slug: "pending-requests"
      });
    }

    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests/fencing",
        name: "Demandes Clôturées",
        slug: "fencing-requests"
      });
    }

    if (is_manager || is_chargerClientele || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests/not-approved",
        name: "Demandes à approuver",
        slug: "closed-requests"
      });
    }

    if (is_chargerClientele || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests/mail",
        name: "Demandes par mail",
        slug: "mail-requests"
      });
    }

    if (submenu.length) {
      array.push({
        url: null,
        name: "Demandes",
        icon: "MessageSquareIcon",
        submenu: submenu
      });
    }
    if (is_admin || is_manager || is_chargerClientele || is_dispatcher) {
      array.push({
        url: "/folders",
        name: "Dossiers",
        slug: "folders",
        icon: "FolderIcon"
      })
    }
    if (is_dispatcher) {
      array.push({
        url: "/archives",
        name: "Archives",
        slug: "archives",
        icon: "ArchiveIcon"
      })
    }

    if (is_admin) {
      array.push({
        url: "/third-party",
        name: "Third Party",
        slug: "thirdparty",
        icon: "LinkIcon"
      })
    }

    // Facturations
    submenu = [];

    if (is_chargerClientele || is_client || is_mandataire || is_manager) {
      submenu.push({
        url: '/invoices',
        name: "Factures",
        slug: ""
      });
    }

    if (is_chargerClientele || is_client || is_mandataire) {
      submenu.push({
        url: null,
        name: "Règlements",
        slug: ""
      });
    }

    submenu_1 = [];
    if (is_admin || is_manager || is_chargerClientele) {
      submenu_1.push({
        url: '/uploads/invoices',
        name: 'Factures',
        slug: ""
      }, {
        url: '/uploads/payments',
        name: 'Réglement',
        slug: ""
      });
    }

    if (is_chargerClientele) {
      submenu_1.push({
        url: '/uploads/payments',
        name: 'Règlements',
        slug: ""
      });
    }

    if (submenu_1.length) {
      submenu.push({
        url: null,
        name: "Uploads",
        submenu: submenu_1
      });
      submenu_1 = [];
    }

    if (submenu.length) {
      /*array.push({
        url: null,
        name: "Facturations",
        icon: "FileTextIcon",
        submenu: submenu
      });*/
    }

    // Statistiques
    submenu = [];

    if (is_client) {
      submenu.push({
        url: '/statistics/customer',
        name: 'Statistiques clients',
        slug: "stat_customer"
      });
    }

    if (is_chargerClientele) {
      submenu.push({
        url: '/statistics/cc',
        name: 'Statistiques Chargé de clientèle',
        slug: "stat_cc"
      }, {
        url: '/statistics/request',
        name: 'Statistiques requête',
        slug: "stat_req"
      });
    }

    if (is_manager) {
      submenu.push({
        url: '/statistics/manager',
        name: 'Statistiques Manager',
        slug: ""
      });
    }
    if (is_dispatcher || is_admin || is_manager) {
      submenu.push({
        url: '/statistics/request',
        name: 'Statistiques requête',
        slug: "stat_req"
      })
      submenu.push({
        url: '/statistics/ebu',
        name: 'Statistiques EBU',
        slug: "statistics_ebu"
      })
      submenu.push({
        url: '/statistics/cex',
        name: 'Statistiques CEX',
        slug: "statistics_cex"
      })
    }
    if (is_dispatcher || is_admin || is_manager || is_chargerClientele || is_commercial) {
      submenu.push({
        url: '/statistics/folder',
        name: 'Statistiques dossiers',
        slug: "stat_folder"
      })
    }

    if (submenu.length) {
      array.push({
        url: null,
        name: 'Statistiques',
        icon: 'ActivityIcon',
        submenu: submenu
      });
    }

    // profile
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      array.push({
        url: '/profile',
        name: 'Profil',
        icon: 'UserIcon',
      });
    }

    // Paramètres
    submenu = [];

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/clients',
        name: 'Clients',
        slug: ""
      });
    }

    // if (is_admin || is_dispatcher) {
    //   submenu.push({
    //     url: '/settings/admin',
    //     name: 'Paramètres Admin',
    //     slug: ""
    //   });
    // }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/segments',
        name: 'segments',
        slug: ""
      });
    }
    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/services',
        name: 'Services',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/approbations',
        name: 'Chaînes d\'approbations',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/categories',
        name: 'Type de demandes',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/types',
        name: 'Sous types de demandes',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/users',
        name: 'Utilisateurs',
        slug: ""
      });
    }

    // if (is_client) {
    //   submenu.push({
    //     url: '/settings/master',
    //     name: 'Paramètres Client Master',
    //     slug: ""
    //   });
    // }

    /*
    if (is_manager) {
      submenu.push({
        url: '/settings',
        name: 'Paramètres Manager',
        slug: ""
      });
    }
    */

    if (submenu.length) {
      array.push({
        url: null,
        name: 'Paramètres',
        icon: 'SettingsIcon',
        submenu: submenu
      });
    }

    return array;
  }
}
